// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FyRv","right":"Footer_right__2Tk_4","buttons":"Footer_buttons__3BJtG"};